'use client'

import { useProductPurchase } from '@/components/client/product/prices/purchase-context'
import { useTranslation } from '@/hooks/client/use-translation'

import { preferredScorecardOffer } from './preferred-scorecard-offer'

import type { ScorecardData } from '../scorecard-types'

interface ScorecardTestedCaptionProps {
  configuration: NonNullable<ScorecardData['testedConfiguration']>
  discontinued: boolean
  familyProductCount: number
}

export const ScorecardTestedCaption = ({
  configuration,
  discontinued,
  familyProductCount,
}: ScorecardTestedCaptionProps) => {
  const purchase = useProductPurchase()
  const { t } = useTranslation()
  if (familyProductCount <= 1) {
    return null
  }
  const offer = preferredScorecardOffer(purchase?.sellers ?? [])
  const hasPrice = !discontinued && !!offer && offer.price > 0
  const isTestedSelection =
    purchase?.selectedModel.id === configuration.modelId && purchase?.selectedLevel.id === configuration.levelId

  return (
    <p className="text-xs leading-relaxed text-white/60" role="status">
      {hasPrice && isTestedSelection
        ? t('product.purchase.verdictAndPriceForModel', 'Verdict and price for model: {{configuration}}', {
            configuration: configuration.label,
          })
        : t('product.purchase.verdictForModel', 'Verdict for model: {{configuration}}', {
            configuration: configuration.label,
          })}
      {hasPrice && !isTestedSelection && purchase && (
        <>
          {'. '}
          {t('product.purchase.priceForSelectedModel', 'Price for selected model: {{configuration}}', {
            configuration: purchase.configuration,
          })}
        </>
      )}
    </p>
  )
}
